import React from 'react'
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import { useDispatch } from "react-redux";
import Button from '@mui/material/Button';
// import UpdateIcon from '@mui/icons-material/Update';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
// import EditNotificationsIcon from '@mui/icons-material/EditNotifications';
import LogoutIcon from '@mui/icons-material/Logout';

// import LockIcon from '@mui/icons-material/Lock';
import PollIcon from '@mui/icons-material/Poll';
import AppLink from '../../../../components/AppLink';
import { logoutAction } from '../../../auth/store/actions';




const AdminSettingsPage = () => {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const handleClick = () => {
    setOpen(!open);
  };

  const logOut = () => {
    handleClick();
    dispatch(logoutAction.request({}));
  }
    return (
        <Box sx={{p:1}}>


<Dialog
        open={open}
        onClose={handleClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Logout?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to logout, You'll have to login again on to access the application on this browser
            
              </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClick}>Cancel</Button>
          <Button onClick={logOut} autoFocus>
           Continue
          </Button>
        </DialogActions>
      </Dialog>


                    <List  sx={{ width: '100%', 
                  bgcolor: 'background.paper' , maxWidth: '500px'}}>
               <ListItem disablePadding>
                   <AppLink to="app-settings/base" doNotUseButton  style={{
                       display: 'block',
                       width: '100%'
                   }}>
            <ListItemButton>
              <ListItemIcon>
                <LoyaltyIcon />
              </ListItemIcon>
              <ListItemText primary="App Settings" secondary={'Set the settings on the mobile app'} />
            </ListItemButton>
            </AppLink>
          </ListItem>

          <ListItem disablePadding>
                   <AppLink to="questionnaires" doNotUseButton  style={{
                       display: 'block',
                       width: '100%'
                   }}>
            <ListItemButton>
              <ListItemIcon>
                <PollIcon />
              </ListItemIcon>
              <ListItemText primary="Questionnaires" secondary={'Create and manage questionnaires'} />
            </ListItemButton>
            </AppLink>
          </ListItem>
{/* 
          <ListItem disablePadding>
                   <AppLink to="/settings/email-templates" doNotUseButton  style={{
                       display: 'block',
                       width: '100%'
                   }}>
            <ListItemButton>
              <ListItemIcon>
                <EditNotificationsIcon />
              </ListItemIcon>
              <ListItemText primary="Emails" secondary={'Manage and send emails to users'} />
            </ListItemButton>
            </AppLink>
          </ListItem> */}
          {/* <ListItem disablePadding>
                   <AppLink to="/settings/profile" doNotUseButton  style={{
                       display: 'block',
                       width: '100%'
                   }}>
            <ListItemButton>
              <ListItemIcon>
                <UpdateIcon />
              </ListItemIcon>
              <ListItemText primary="Update Details" secondary={'Change your Name and or Email'} />
            </ListItemButton>
            </AppLink>
          </ListItem> */}

          {/* <ListItem disablePadding>
                   <AppLink to="/settings/change-password" doNotUseButton  style={{
                       display: 'block',
                       width: '100%'
                   }}>
            <ListItemButton>
              <ListItemIcon>
                <LockIcon />
              </ListItemIcon>
              <ListItemText primary="Change Password" />
            </ListItemButton>
            </AppLink>
          </ListItem> */}
          
          <ListItem disablePadding sx={{ color: 'error.dark' }}>
               
            <ListItemButton style={{color: "inherit"}} onClick={handleClick}>
              <ListItemIcon style={{color: "inherit"}}>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText style={{color: "inherit"}} primary="Log Out" />
            </ListItemButton>
        
          </ListItem>
          
                </List>            
        </Box>
    )
}

export default AdminSettingsPage;